<template>
  <assign-view-form :show-del-btn="showDelBtn" :height="height" :form-fields="formFields">
    <template #action="{ item, index }">
      <el-popover :ref="[refName, index].join('_')" v-bind="popover_config.props">
        <div class="w-full flex items-center justify-between">
          <el-input v-model="title_name" />
          <div class="ml-10 flex-grow-0">
            <span>{{ title_name_len }}</span>
            <span> / </span>
            <span :style="len_limit_style">{{ page_config.rules.max_length }}</span>
          </div>
        </div>
        <div class="pt-10 pb-10">
          插入动态词包：
          <el-link v-for="word in page_config.word_list" :key="word" class="mr-10" :underline="false" type="primary" @click="insertStr(replaceContext(page_config.word_template, word))">+{{ word }}</el-link>
        </div>
        <div class="text-right">
          <el-button size="mini" @click.stop="onCancel(item, index)">取消</el-button>
          <el-button type="primary" size="mini" @click.stop="editTitle(item, title_name, index)">确定</el-button>
        </div>
        <i v-if="showEditButton" slot="reference" class="el-icon-edit-outline mr-10 edit-btn font-16" @click.stop="() => onEdit(item, index)" />
      </el-popover>
    </template>
  </assign-view-form>
</template>

<script>
import { getPageConfig } from '@/views/auxiliary/title/config';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'assign-view-form': () => import('../../components/view-form/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    // 组件的ref部分名称，最终会和标题索引拼接，如assign_title_popover_ref_0
    refName: {
      type: String,
      default: 'assign_title_popover_ref',
    },
    // 当前标题模块表单配置
    formFields: {
      type: Object,
      default() {
        return {};
      },
    },
    // 是否显示删除按钮
    showDelBtn: {
      type: Boolean,
      default: true,
    },
    /** 容器高度 */
    height: {
      type: String,
      default: '400px',
    },
    /** 是否显示编辑按钮 */
    showEditButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      title_name: '', // 标题
      page_config: {}, // 页面配置项
      // popover组件配置
      popover_config: {
        props: {
          appendToBody: true,
          popperOptions: {
            boundariesElement: 'body',
            gpuAcceleration: true,
            positionFixed: true,
            preventOverflow: true,
          },
          placement: 'left',
          width: '400',
          trigger: 'manual',
        },
      },
    };
  },
  computed: {
    /**
     * 标题的长度
     * @returns {number}
     */
    title_name_len() {
      return this.title_name.length;
    },
    /**
     * 提示信息的样式
     * @returns {Object}
     */
    len_limit_style() {
      return {
        color: this.title_name_len > this.page_config.rules.max_length ? '#f45858' : 'inherit',
      };
    },
  },
  created() {
    const form_context = this.local_sharing_data.getFormContext();
    const { init_ops } = form_context.config;
    const { channel_interface } = init_ops;
    Object.assign(this.page_config, getPageConfig(`title-list-${channel_interface}`));
  },
  methods: {
    /**
     * 替换文本
     * @param {string} template 词包模板
     * @param {string} value 输入的值
     * @returns {string} 被替换后的值
     * @example
     * replaceContext("{context}", "性别");
     * 输出："{性别}"
     */
    replaceContext(template, value) {
      return template.replace(/context/g, value);
    },

    /**
     * 批量新增插入动态词包
     * @param {string} str 词包
     * @returns {void}
     */
    insertStr(str) {
      this.title_name += str;
    },
    /**
     * 修改标题
     * @param {Object} title_item 标题项
     * @param {string} str 修改字符串
     * @param {number} index 索引位置
     * @returns {void}
     */
    editTitle(title_item, str, index) {
      const str_len = str.length;
      if (str_len >= 1 && str_len <= this.page_config.rules.max_length) {
        title_item.name = str;
        this.$emit('change');
        this.onCancel(title_item, index);
      } else {
        this.$message({
          showClose: true,
          message: `标题1到${this.page_config.rules.max_length}个字符`,
          type: 'error',
        });
      }
    },

    /**
     * 关闭所有的Popover
     * @returns {void}
     */
    closeAllPopover() {
      for (const key in this.$refs) {
        if (key.indexOf(this.refName) !== -1) {
          this.$refs[key]?.doClose?.();
        }
      }
    },

    /**
     * 编辑标题
     * @param {Object} item 标题数据
     * @param {number} index 索引位置
     * @returns {void}
     */
    onEdit(item, index) {
      this.closeAllPopover();
      item.is_title_pop = true;
      this.title_name = item.name;
      const ref_name = [this.refName, index].join('_');
      this.$refs[ref_name]?.doShow?.();
    },

    /**
     * 取消编辑标题
     * @param {Object} item 标题数据
     * @param {number} index 索引位置
     * @returns {void}
     */
    onCancel(item, index) {
      item.is_title_pop = false;
      const ref_name = [this.refName, index].join('_');
      this.$refs[ref_name]?.doClose?.();
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-btn {
  &:hover {
    color: #409EFF;
  }
}
</style>
